import React, { useMemo } from 'react';
import { TIMELINE_HORIZONTAL_PADDING } from '../../constants';
import { TimelineTrackAndLayout } from '../utils/drag/calculate-track-heights';
import { TimelineGutter } from './timeline-gutter';
import {
  getZoneBoundaryIndex,
  ZONE_SEPARATOR_HEIGHT,
} from '../../utils/zone-utils';

export const TimelineBackground: React.FC<{
  tracks: TimelineTrackAndLayout[];
  timelineWidth: number;
  inbetweenTrackDropTrackIndex: number | null;
}> = ({ tracks, timelineWidth, inbetweenTrackDropTrackIndex }) => {
  const zoneBoundaryIndex = useMemo(
    () => getZoneBoundaryIndex(tracks.map((track) => track.track)),
    [tracks],
  );

  const style: React.CSSProperties = useMemo(() => {
    return {
      width: timelineWidth + TIMELINE_HORIZONTAL_PADDING * 2,
      marginLeft: -TIMELINE_HORIZONTAL_PADDING,
    };
  }, [timelineWidth]);

  return (
    <div
      className="absolute"
      style={style}
    >
      {tracks.map((track, i) => (
        <React.Fragment key={track.track.id}>
          {i === zoneBoundaryIndex &&
          zoneBoundaryIndex > 0 &&
          zoneBoundaryIndex < tracks.length ? (
            <div
              className="pointer-events-none border-t-4 border-sys-style-neutral-default"
              style={{
                height: ZONE_SEPARATOR_HEIGHT,
                width: timelineWidth + TIMELINE_HORIZONTAL_PADDING * 2,
              }}
            />
          ) : null}
          <TimelineGutter
            track={track}
            timelineWidth={timelineWidth}
            inbetweenTrackDropTrackIndex={inbetweenTrackDropTrackIndex}
            trackIndex={i}
          />
        </React.Fragment>
      ))}
    </div>
  );
};
